import env from '~/src/utils/env';
export const CLIO_IDENTITY_SECURITY_URL = `${env.clioIdentityBaseUrl}/security/personal`;
